import { usePyramid } from "../api";
import { ErrorBox, Empty, Loading } from "../components/State";

const initials = (name: string) =>
  name
    .split(/\s+/)
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

export default function Pyramid() {
  const { data, loading, error } = usePyramid();
  if (loading) return <Loading what="org pyramid" />;
  if (error) return <ErrorBox error={error} what="org pyramid" />;

  const levels = data?.levels ?? [];
  if (!levels.length) return <Empty what="org levels" />;

  const vacancies = levels.flatMap((l) => l.seats.filter((s) => s.isVacancy));

  return (
    <>
      <div className="card">
        <h2>Org pyramid</h2>
        <p>
          Four levels, every seat either filled or open. The shape of the company at a glance —
          {" "}
          {vacancies.length} open {vacancies.length === 1 ? "seat" : "seats"}.
        </p>
      </div>

      <div className="pyramid">
        {levels.map((l) => (
          <div className="band" key={l.id}>
            <div className="row" style={{ justifyContent: "space-between", alignItems: "baseline" }}>
              <strong>
                L{l.levelIndex} · {l.name}
              </strong>
              <span className="badge">{l.subtitle ?? ""}</span>
            </div>
            <div className="seats">
              {l.seats.length === 0 && <span>No seats defined.</span>}
              {l.seats.map((s) =>
                s.isVacancy ? (
                  <div className="seat" key={s.id} style={{ borderStyle: "dashed", opacity: 0.85 }}>
                    <div className="avatar">+</div>
                    <div>
                      <strong>Open seat</strong>
                      <div>{s.vacancyTitle ?? "Vacancy"}</div>
                    </div>
                  </div>
                ) : (
                  <div className="seat" key={s.id}>
                    <div className="avatar">{initials(s.personName ?? "?")}</div>
                    <div>
                      <strong>{s.personName}</strong>
                      <div>{s.roleTitle ?? "—"}</div>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        ))}
      </div>

      {vacancies.length > 0 && (
        <div className="card">
          <h2>Open seats</h2>
          <ul>
            {vacancies.map((v) => (
              <li key={v.id}>{v.vacancyTitle}</li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
}
